<template>
  <div>
    <div class="content" v-for="(item, index) in invoiceList" :key="index">
      <div class="con">
        <div class="title">
          <span class="t">抬头</span>
          <span class="gs">{{ item.header }}</span>
        </div>
        <div class="st">{{ item._status }}</div>
      </div>
      <div class="timer">申请时间：{{ item.time }}</div>
      <div class="money">
        已开金额：<span class="m">￥{{ item.pay_price }}</span>
      </div>
    </div>
    <Loading :loaded="loadend" :loading="loading"></Loading>
  </div>
</template>

<script>
import { postInvoiceList } from "@api/user";
import Loading from "@components/Loading";

export default {
  name: "InvoiceList",
  components: {
    Loading,
  },
  data() {
    return {
      page: 1,
      limit: 20,
      invoiceList: [],
      loading: false,
      loadend: false,
    };
  },
  mounted: function() {
    this.getInvoiceList();
  },
  methods: {
    getInvoiceList() {
      let that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      postInvoiceList({ page: that.page, limit: that.limit }).then((res) => {
        that.loading = false;
        //apply();js将一个数组插入另一个数组;
        that.invoiceList.push.apply(that.invoiceList, res.data);
        that.loadend = res.data.length < that.limit; //判断所有数据是否加载完成；
        that.page = that.page + 1;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  background: white;
  margin: 20px 10px;
  padding: 20px;
  border-radius: 15px;
  .con {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      display: flex;
      align-items: center;
      .t {
        font-size: 12px;
        color: red;
        border-radius: 5px;
        padding: 2px 6px;
        background: rgb(255, 202, 202);
      }
      .gs {
        font-size: 20px;
        font-weight: 600;
        margin-left: 20px;
      }
      .st {
        font-size: 18px;
      }
    }
  }
  .timer {
    margin: 10px 0;
  }
  .money {
    .m {
      font-size: 20px;
      color: red;
    }
  }
}

.title-box {
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 0.96rem;
  display: flex;
  justify-content: space-between; /* 左右贴边，中间自适应 */
  align-items: center; /* 垂直居中（可选） */
  background: white;
  border-bottom: #f0f0f0 1px solid;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
  .title-box:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* 悬停时阴影变大 */
  }

  .title {
    margin: 0 auto; /* 关键：让中间元素自动居中 */
    letter-spacing: 1px;
  }
  .return {
    display: flex;
    flex-direction: row;
    align-items: center;
    .lg {
      width: 24px;
      height: 24px;
    }
    .close {
      font-size: 15px;
      margin-left: 10px;
    }
  }
}
</style>
